import React, { useRef } from 'react';
import './App.css';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import SocialProofSection from './components/SocialProofSection';
import HowItWorksSection from './components/HowItWorksSection';
import ForBusinessesSection from './components/ForBusinessesSection';
import ForStaffSection from './components/ForStaffSection';
import TrustSection from './components/TrustSection';
import WaitlistSection from './components/WaitlistSection';
import Footer from './components/Footer';

function App() {
  const waitlistRef = useRef(null);

  const scrollToWaitlist = () => {
    const element = document.getElementById('waitlist');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="App">
      <Header onJoinWaitlist={scrollToWaitlist} />
      <HeroSection
        onJoinWaitlist={scrollToWaitlist}
        onForBusinesses={() => scrollToSection('for-businesses')}
        onForStaff={() => scrollToSection('for-staff')}
      />
      <SocialProofSection count="5k+" />
      <HowItWorksSection />
      <ForBusinessesSection />
      <ForStaffSection />
      <TrustSection />
      <div ref={waitlistRef}>
        <WaitlistSection />
      </div>
      <Footer />
    </div>
  );
}

export default App;
